<div class="biometric-login-container">
  <div class="login-card">
    <div class="header">
      <h1>🔐 Authentification Biométrique</h1>
      <p class="subtitle">{{ mode === 'login' ? 'Connectez-vous' : 'Enregistrez-vous' }} avec votre empreinte digitale</p>
    </div>

    <!-- Message si non supporté -->
    @if (!isSupported) {
      <div class="alert alert-error">
        <span class="icon">⚠️</span>
        <div>
          <strong>Authentification biométrique non supportée</strong>
          <p>Votre navigateur ne supporte pas WebAuthn. Veuillez utiliser un navigateur récent (Chrome, Firefox, Safari, Edge).</p>
        </div>
      </div>
    }

    <!-- Message si pas d'authentificateur de plateforme -->
    @if (isSupported && !platformAuthenticator) {
      <div class="alert alert-warning">
        <span class="icon">ℹ️</span>
        <div>
          <strong>Authentificateur non détecté</strong>
          <p>Aucun lecteur d'empreinte ou Face ID détecté sur cet appareil. Vous pouvez utiliser une clé de sécurité USB.</p>
        </div>
      </div>
    }

    <!-- Formulaire -->
    @if (isSupported) {
      <form class="form">
        <!-- Mode Connexion -->
        @if (mode === 'login') {
          <div>
            <div class="form-group">
              <label for="username">Nom d'utilisateur</label>
              <input
                type="text"
                id="username"
                [(ngModel)]="username"
                name="username"
                placeholder="Entrez votre nom d'utilisateur"
                [disabled]="isLoading"
                required
                />
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="loginWithFingerprint()"
                [disabled]="isLoading || !username.trim()"
                >
                @if (!isLoading) {
                  <span>🔓 Se connecter avec l'empreinte</span>
                }
                @if (isLoading) {
                  <span>⏳ Authentification en cours...</span>
                }
              </button>
            </div>
          }
          <!-- Mode Enregistrement -->
          @if (mode === 'register') {
            <div>
              <div class="form-group">
                <label for="reg-username">Nom d'utilisateur <span class="required">*</span></label>
                <input
                  type="text"
                  id="reg-username"
                  [(ngModel)]="username"
                  name="reg-username"
                  placeholder="Choisissez un nom d'utilisateur"
                  [disabled]="isLoading"
                  required
                  />
                </div>
                <div class="form-group">
                  <label for="email">Email <span class="required">*</span></label>
                  <input
                    type="email"
                    id="email"
                    [(ngModel)]="email"
                    name="email"
                    placeholder="votre@email.com"
                    [disabled]="isLoading"
                    required
                    />
                  </div>
                  <div class="form-group">
                    <label for="displayName">Nom d'affichage</label>
                    <input
                      type="text"
                      id="displayName"
                      [(ngModel)]="displayName"
                      name="displayName"
                      placeholder="Votre nom complet (optionnel)"
                      [disabled]="isLoading"
                      />
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="registerFingerprint()"
                      [disabled]="isLoading || !username.trim() || !email.trim()"
                      >
                      @if (!isLoading) {
                        <span>✋ Enregistrer mon empreinte</span>
                      }
                      @if (isLoading) {
                        <span>⏳ Enregistrement en cours...</span>
                      }
                    </button>
                  </div>
                }
                <!-- Messages -->
                @if (errorMessage) {
                  <div class="alert alert-error">
                    <span class="icon">❌</span>
                    <p>{{ errorMessage }}</p>
                  </div>
                }
                @if (successMessage) {
                  <div class="alert alert-success">
                    <span class="icon">✅</span>
                    <p>{{ successMessage }}</p>
                  </div>
                }
                <!-- Basculer entre login et register -->
                <div class="toggle-mode">
                  @if (mode === 'login') {
                    <p>
                      Pas encore d'empreinte enregistrée ?
                      <button type="button" class="btn-link" (click)="toggleMode()">Créer un compte</button>
                    </p>
                  }
                  @if (mode === 'register') {
                    <p>
                      Déjà enregistré ?
                      <button type="button" class="btn-link" (click)="toggleMode()">Se connecter</button>
                    </p>
                  }
                </div>
              </form>
            }

            <!-- Info -->
            <div class="info">
              <p>🔒 <strong>Sécurisé</strong> : Votre empreinte reste sur votre appareil</p>
              <p>⚡ <strong>Rapide</strong> : Connexion instantanée</p>
              <p>🌐 <strong>Standard</strong> : Compatible avec WebAuthn (W3C)</p>
            </div>
          </div>
        </div>
